import React, { useState } from 'react';

function Tooltip({ children, text, position = 'bottom' }) {
  const [isVisible, setIsVisible] = useState(false);

  const positionStyles = {
    bottom: {
      top: '100%',
      left: '50%',
      transform: 'translateX(-50%) translateY(8px)',
    },
    top: {
      bottom: '100%',
      left: '50%',
      transform: 'translateX(-50%) translateY(-8px)',
    },
    left: {
      right: '100%',
      top: '50%',
      transform: 'translateX(-8px) translateY(-50%)',
    },
    right: {
      left: '100%',
      top: '50%',
      transform: 'translateX(8px) translateY(-50%)',
    },
  };

  return (
    <div 
      style={{ position: 'relative', display: 'inline-flex' }}
      onMouseEnter={() => setIsVisible(true)}
      onMouseLeave={() => setIsVisible(false)}
    >
      {children}
      {isVisible && text && (
        <div
          style={{
            position: 'absolute',
            ...positionStyles[position],
            padding: '12px',
            background: '#070707',
            border: '1px solid rgba(96, 210, 204, 0.2)',
            borderRadius: '16px',
            fontFamily: "'Figtree', -apple-system, BlinkMacSystemFont, sans-serif",
            fontSize: '12px',
            lineHeight: '18px',
            color: '#a3a3a3',
            whiteSpace: 'nowrap',
            zIndex: 10000,
            pointerEvents: 'none',
            boxShadow: '0px 8px 10px -6px rgba(96, 210, 204, 0.2)',
            backdropFilter: 'blur(8px)',
            WebkitBackdropFilter: 'blur(8px)',
          }}
        >
          {text}
        </div>
      )}
    </div>
  );
}

export default Tooltip;

